import { render, staticRenderFns, recyclableRender, components } from "./u-line.vue?vue&type=template&id=727e452e&scoped=true&"
var renderjs
import script from "./u-line.vue?vue&type=script&lang=js&"
export * from "./u-line.vue?vue&type=script&lang=js&"
import style0 from "./u-line.vue?vue&type=style&index=0&id=727e452e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727e452e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-line/u-line.vue"
export default component.exports